"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketParams = exports.Market = exports.ControlledParams = exports.Params = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const duration_1 = require("../google/protobuf/duration");
const timestamp_1 = require("../google/protobuf/timestamp");
const wrappers_1 = require("../google/protobuf/wrappers");
exports.protobufPackage = "Switcheo.carbon.market";
const baseParams = {
    defaultLotSizeUsd: "",
    defaultTickSizeUsd: "",
    defaultMinQuantityUsd: "",
    defaultSpotMakerFee: "",
    defaultSpotTakerFee: "",
    defaultFuturesMakerFee: "",
    defaultFuturesTakerFee: "",
    defaultRiskStepSizeUsd: "",
    defaultInitialMarginBase: "",
    defaultInitialMarginStep: "",
    defaultMaintenanceMarginRatio: "",
    defaultMaxLiquidationOrderTicketUsd: "",
    defaultImpactSizeUsd: "",
    defaultMarkPriceBand: 0,
    defaultLastPriceProtectedBand: 0,
    maxActiveMarkets: 0,
    defaultTradingBandwidth: 0,
    fundingRateBand: "",
};
exports.Params = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.defaultLotSizeUsd !== "") {
            writer.uint32(10).string(message.defaultLotSizeUsd);
        }
        if (message.defaultTickSizeUsd !== "") {
            writer.uint32(18).string(message.defaultTickSizeUsd);
        }
        if (message.defaultMinQuantityUsd !== "") {
            writer.uint32(26).string(message.defaultMinQuantityUsd);
        }
        if (message.defaultSpotMakerFee !== "") {
            writer.uint32(34).string(message.defaultSpotMakerFee);
        }
        if (message.defaultSpotTakerFee !== "") {
            writer.uint32(42).string(message.defaultSpotTakerFee);
        }
        if (message.defaultFuturesMakerFee !== "") {
            writer.uint32(50).string(message.defaultFuturesMakerFee);
        }
        if (message.defaultFuturesTakerFee !== "") {
            writer.uint32(58).string(message.defaultFuturesTakerFee);
        }
        if (message.defaultRiskStepSizeUsd !== "") {
            writer.uint32(66).string(message.defaultRiskStepSizeUsd);
        }
        if (message.defaultInitialMarginBase !== "") {
            writer.uint32(74).string(message.defaultInitialMarginBase);
        }
        if (message.defaultInitialMarginStep !== "") {
            writer.uint32(82).string(message.defaultInitialMarginStep);
        }
        if (message.defaultMaintenanceMarginRatio !== "") {
            writer.uint32(90).string(message.defaultMaintenanceMarginRatio);
        }
        if (message.defaultMaxLiquidationOrderTicketUsd !== "") {
            writer.uint32(98).string(message.defaultMaxLiquidationOrderTicketUsd);
        }
        if (message.defaultMaxLiquidationOrderDuration !== undefined) {
            duration_1.Duration.encode(message.defaultMaxLiquidationOrderDuration, writer.uint32(106).fork()).ldelim();
        }
        if (message.defaultImpactSizeUsd !== "") {
            writer.uint32(114).string(message.defaultImpactSizeUsd);
        }
        if (message.defaultMarkPriceBand !== 0) {
            writer.uint32(120).uint32(message.defaultMarkPriceBand);
        }
        if (message.defaultLastPriceProtectedBand !== 0) {
            writer.uint32(128).uint32(message.defaultLastPriceProtectedBand);
        }
        if (message.maxActiveMarkets !== 0) {
            writer.uint32(136).uint32(message.maxActiveMarkets);
        }
        if (message.defaultTradingBandwidth !== 0) {
            writer.uint32(144).uint32(message.defaultTradingBandwidth);
        }
        if (message.fundingRateBand !== "") {
            writer.uint32(154).string(message.fundingRateBand);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseParams);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.defaultLotSizeUsd = reader.string();
                    break;
                case 2:
                    message.defaultTickSizeUsd = reader.string();
                    break;
                case 3:
                    message.defaultMinQuantityUsd = reader.string();
                    break;
                case 4:
                    message.defaultSpotMakerFee = reader.string();
                    break;
                case 5:
                    message.defaultSpotTakerFee = reader.string();
                    break;
                case 6:
                    message.defaultFuturesMakerFee = reader.string();
                    break;
                case 7:
                    message.defaultFuturesTakerFee = reader.string();
                    break;
                case 8:
                    message.defaultRiskStepSizeUsd = reader.string();
                    break;
                case 9:
                    message.defaultInitialMarginBase = reader.string();
                    break;
                case 10:
                    message.defaultInitialMarginStep = reader.string();
                    break;
                case 11:
                    message.defaultMaintenanceMarginRatio = reader.string();
                    break;
                case 12:
                    message.defaultMaxLiquidationOrderTicketUsd = reader.string();
                    break;
                case 13:
                    message.defaultMaxLiquidationOrderDuration = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                case 14:
                    message.defaultImpactSizeUsd = reader.string();
                    break;
                case 15:
                    message.defaultMarkPriceBand = reader.uint32();
                    break;
                case 16:
                    message.defaultLastPriceProtectedBand = reader.uint32();
                    break;
                case 17:
                    message.maxActiveMarkets = reader.uint32();
                    break;
                case 18:
                    message.defaultTradingBandwidth = reader.uint32();
                    break;
                case 19:
                    message.fundingRateBand = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseParams);
        message.defaultLotSizeUsd =
            object.defaultLotSizeUsd !== undefined &&
                object.defaultLotSizeUsd !== null
                ? String(object.defaultLotSizeUsd)
                : "";
        message.defaultTickSizeUsd =
            object.defaultTickSizeUsd !== undefined &&
                object.defaultTickSizeUsd !== null
                ? String(object.defaultTickSizeUsd)
                : "";
        message.defaultMinQuantityUsd =
            object.defaultMinQuantityUsd !== undefined &&
                object.defaultMinQuantityUsd !== null
                ? String(object.defaultMinQuantityUsd)
                : "";
        message.defaultSpotMakerFee =
            object.defaultSpotMakerFee !== undefined &&
                object.defaultSpotMakerFee !== null
                ? String(object.defaultSpotMakerFee)
                : "";
        message.defaultSpotTakerFee =
            object.defaultSpotTakerFee !== undefined &&
                object.defaultSpotTakerFee !== null
                ? String(object.defaultSpotTakerFee)
                : "";
        message.defaultFuturesMakerFee =
            object.defaultFuturesMakerFee !== undefined &&
                object.defaultFuturesMakerFee !== null
                ? String(object.defaultFuturesMakerFee)
                : "";
        message.defaultFuturesTakerFee =
            object.defaultFuturesTakerFee !== undefined &&
                object.defaultFuturesTakerFee !== null
                ? String(object.defaultFuturesTakerFee)
                : "";
        message.defaultRiskStepSizeUsd =
            object.defaultRiskStepSizeUsd !== undefined &&
                object.defaultRiskStepSizeUsd !== null
                ? String(object.defaultRiskStepSizeUsd)
                : "";
        message.defaultInitialMarginBase =
            object.defaultInitialMarginBase !== undefined &&
                object.defaultInitialMarginBase !== null
                ? String(object.defaultInitialMarginBase)
                : "";
        message.defaultInitialMarginStep =
            object.defaultInitialMarginStep !== undefined &&
                object.defaultInitialMarginStep !== null
                ? String(object.defaultInitialMarginStep)
                : "";
        message.defaultMaintenanceMarginRatio =
            object.defaultMaintenanceMarginRatio !== undefined &&
                object.defaultMaintenanceMarginRatio !== null
                ? String(object.defaultMaintenanceMarginRatio)
                : "";
        message.defaultMaxLiquidationOrderTicketUsd =
            object.defaultMaxLiquidationOrderTicketUsd !== undefined &&
                object.defaultMaxLiquidationOrderTicketUsd !== null
                ? String(object.defaultMaxLiquidationOrderTicketUsd)
                : "";
        message.defaultMaxLiquidationOrderDuration =
            object.defaultMaxLiquidationOrderDuration !== undefined &&
                object.defaultMaxLiquidationOrderDuration !== null
                ? duration_1.Duration.fromJSON(object.defaultMaxLiquidationOrderDuration)
                : undefined;
        message.defaultImpactSizeUsd =
            object.defaultImpactSizeUsd !== undefined &&
                object.defaultImpactSizeUsd !== null
                ? String(object.defaultImpactSizeUsd)
                : "";
        message.defaultMarkPriceBand =
            object.defaultMarkPriceBand !== undefined &&
                object.defaultMarkPriceBand !== null
                ? Number(object.defaultMarkPriceBand)
                : 0;
        message.defaultLastPriceProtectedBand =
            object.defaultLastPriceProtectedBand !== undefined &&
                object.defaultLastPriceProtectedBand !== null
                ? Number(object.defaultLastPriceProtectedBand)
                : 0;
        message.maxActiveMarkets =
            object.maxActiveMarkets !== undefined && object.maxActiveMarkets !== null
                ? Number(object.maxActiveMarkets)
                : 0;
        message.defaultTradingBandwidth =
            object.defaultTradingBandwidth !== undefined &&
                object.defaultTradingBandwidth !== null
                ? Number(object.defaultTradingBandwidth)
                : 0;
        message.fundingRateBand =
            object.fundingRateBand !== undefined && object.fundingRateBand !== null
                ? String(object.fundingRateBand)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.defaultLotSizeUsd !== undefined &&
            (obj.defaultLotSizeUsd = message.defaultLotSizeUsd);
        message.defaultTickSizeUsd !== undefined &&
            (obj.defaultTickSizeUsd = message.defaultTickSizeUsd);
        message.defaultMinQuantityUsd !== undefined &&
            (obj.defaultMinQuantityUsd = message.defaultMinQuantityUsd);
        message.defaultSpotMakerFee !== undefined &&
            (obj.defaultSpotMakerFee = message.defaultSpotMakerFee);
        message.defaultSpotTakerFee !== undefined &&
            (obj.defaultSpotTakerFee = message.defaultSpotTakerFee);
        message.defaultFuturesMakerFee !== undefined &&
            (obj.defaultFuturesMakerFee = message.defaultFuturesMakerFee);
        message.defaultFuturesTakerFee !== undefined &&
            (obj.defaultFuturesTakerFee = message.defaultFuturesTakerFee);
        message.defaultRiskStepSizeUsd !== undefined &&
            (obj.defaultRiskStepSizeUsd = message.defaultRiskStepSizeUsd);
        message.defaultInitialMarginBase !== undefined &&
            (obj.defaultInitialMarginBase = message.defaultInitialMarginBase);
        message.defaultInitialMarginStep !== undefined &&
            (obj.defaultInitialMarginStep = message.defaultInitialMarginStep);
        message.defaultMaintenanceMarginRatio !== undefined &&
            (obj.defaultMaintenanceMarginRatio =
                message.defaultMaintenanceMarginRatio);
        message.defaultMaxLiquidationOrderTicketUsd !== undefined &&
            (obj.defaultMaxLiquidationOrderTicketUsd =
                message.defaultMaxLiquidationOrderTicketUsd);
        message.defaultMaxLiquidationOrderDuration !== undefined &&
            (obj.defaultMaxLiquidationOrderDuration =
                message.defaultMaxLiquidationOrderDuration
                    ? duration_1.Duration.toJSON(message.defaultMaxLiquidationOrderDuration)
                    : undefined);
        message.defaultImpactSizeUsd !== undefined &&
            (obj.defaultImpactSizeUsd = message.defaultImpactSizeUsd);
        message.defaultMarkPriceBand !== undefined &&
            (obj.defaultMarkPriceBand = message.defaultMarkPriceBand);
        message.defaultLastPriceProtectedBand !== undefined &&
            (obj.defaultLastPriceProtectedBand =
                message.defaultLastPriceProtectedBand);
        message.maxActiveMarkets !== undefined &&
            (obj.maxActiveMarkets = message.maxActiveMarkets);
        message.defaultTradingBandwidth !== undefined &&
            (obj.defaultTradingBandwidth = message.defaultTradingBandwidth);
        message.fundingRateBand !== undefined &&
            (obj.fundingRateBand = message.fundingRateBand);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        const message = Object.assign({}, baseParams);
        message.defaultLotSizeUsd = (_a = object.defaultLotSizeUsd) !== null && _a !== void 0 ? _a : "";
        message.defaultTickSizeUsd = (_b = object.defaultTickSizeUsd) !== null && _b !== void 0 ? _b : "";
        message.defaultMinQuantityUsd = (_c = object.defaultMinQuantityUsd) !== null && _c !== void 0 ? _c : "";
        message.defaultSpotMakerFee = (_d = object.defaultSpotMakerFee) !== null && _d !== void 0 ? _d : "";
        message.defaultSpotTakerFee = (_e = object.defaultSpotTakerFee) !== null && _e !== void 0 ? _e : "";
        message.defaultFuturesMakerFee = (_f = object.defaultFuturesMakerFee) !== null && _f !== void 0 ? _f : "";
        message.defaultFuturesTakerFee = (_g = object.defaultFuturesTakerFee) !== null && _g !== void 0 ? _g : "";
        message.defaultRiskStepSizeUsd = (_h = object.defaultRiskStepSizeUsd) !== null && _h !== void 0 ? _h : "";
        message.defaultInitialMarginBase = (_j = object.defaultInitialMarginBase) !== null && _j !== void 0 ? _j : "";
        message.defaultInitialMarginStep = (_k = object.defaultInitialMarginStep) !== null && _k !== void 0 ? _k : "";
        message.defaultMaintenanceMarginRatio =
            (_l = object.defaultMaintenanceMarginRatio) !== null && _l !== void 0 ? _l : "";
        message.defaultMaxLiquidationOrderTicketUsd =
            (_m = object.defaultMaxLiquidationOrderTicketUsd) !== null && _m !== void 0 ? _m : "";
        message.defaultMaxLiquidationOrderDuration =
            object.defaultMaxLiquidationOrderDuration !== undefined &&
                object.defaultMaxLiquidationOrderDuration !== null
                ? duration_1.Duration.fromPartial(object.defaultMaxLiquidationOrderDuration)
                : undefined;
        message.defaultImpactSizeUsd = (_o = object.defaultImpactSizeUsd) !== null && _o !== void 0 ? _o : "";
        message.defaultMarkPriceBand = (_p = object.defaultMarkPriceBand) !== null && _p !== void 0 ? _p : 0;
        message.defaultLastPriceProtectedBand =
            (_q = object.defaultLastPriceProtectedBand) !== null && _q !== void 0 ? _q : 0;
        message.maxActiveMarkets = (_r = object.maxActiveMarkets) !== null && _r !== void 0 ? _r : 0;
        message.defaultTradingBandwidth = (_s = object.defaultTradingBandwidth) !== null && _s !== void 0 ? _s : 0;
        message.fundingRateBand = (_t = object.fundingRateBand) !== null && _t !== void 0 ? _t : "";
        return message;
    },
};
const baseControlledParams = {};
exports.ControlledParams = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.perpetualsFundingInterval !== undefined) {
            duration_1.Duration.encode(message.perpetualsFundingInterval, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseControlledParams);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.perpetualsFundingInterval = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseControlledParams);
        message.perpetualsFundingInterval =
            object.perpetualsFundingInterval !== undefined &&
                object.perpetualsFundingInterval !== null
                ? duration_1.Duration.fromJSON(object.perpetualsFundingInterval)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.perpetualsFundingInterval !== undefined &&
            (obj.perpetualsFundingInterval = message.perpetualsFundingInterval
                ? duration_1.Duration.toJSON(message.perpetualsFundingInterval)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseControlledParams);
        message.perpetualsFundingInterval =
            object.perpetualsFundingInterval !== undefined &&
                object.perpetualsFundingInterval !== null
                ? duration_1.Duration.fromPartial(object.perpetualsFundingInterval)
                : undefined;
        return message;
    },
};
const baseMarket = {
    name: "",
    displayName: "",
    description: "",
    marketType: "",
    base: "",
    quote: "",
    basePrecision: long_1.default.ZERO,
    quotePrecision: long_1.default.ZERO,
    lotSize: "",
    tickSize: "",
    minQuantity: "",
    makerFee: "",
    takerFee: "",
    createdBlockHeight: long_1.default.UZERO,
    riskStepSize: "",
    initialMarginBase: "",
    initialMarginStep: "",
    maintenanceMarginRatio: "",
    maxLiquidationOrderTicket: "",
    impactSize: "",
    markPriceBand: 0,
    lastPriceProtectedBand: 0,
    indexOracleId: "",
    isActive: false,
    isSettled: false,
    closedBlockHeight: long_1.default.UZERO,
    tradingBandwidth: 0,
};
exports.Market = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.name !== "") {
            writer.uint32(10).string(message.name);
        }
        if (message.displayName !== "") {
            writer.uint32(18).string(message.displayName);
        }
        if (message.description !== "") {
            writer.uint32(26).string(message.description);
        }
        if (message.marketType !== "") {
            writer.uint32(34).string(message.marketType);
        }
        if (message.base !== "") {
            writer.uint32(42).string(message.base);
        }
        if (message.quote !== "") {
            writer.uint32(50).string(message.quote);
        }
        if (!message.basePrecision.isZero()) {
            writer.uint32(56).int64(message.basePrecision);
        }
        if (!message.quotePrecision.isZero()) {
            writer.uint32(64).int64(message.quotePrecision);
        }
        if (message.lotSize !== "") {
            writer.uint32(74).string(message.lotSize);
        }
        if (message.tickSize !== "") {
            writer.uint32(82).string(message.tickSize);
        }
        if (message.minQuantity !== "") {
            writer.uint32(90).string(message.minQuantity);
        }
        if (message.makerFee !== "") {
            writer.uint32(98).string(message.makerFee);
        }
        if (message.takerFee !== "") {
            writer.uint32(106).string(message.takerFee);
        }
        if (!message.createdBlockHeight.isZero()) {
            writer.uint32(112).uint64(message.createdBlockHeight);
        }
        if (message.riskStepSize !== "") {
            writer.uint32(802).string(message.riskStepSize);
        }
        if (message.initialMarginBase !== "") {
            writer.uint32(810).string(message.initialMarginBase);
        }
        if (message.initialMarginStep !== "") {
            writer.uint32(818).string(message.initialMarginStep);
        }
        if (message.maintenanceMarginRatio !== "") {
            writer.uint32(826).string(message.maintenanceMarginRatio);
        }
        if (message.maxLiquidationOrderTicket !== "") {
            writer.uint32(834).string(message.maxLiquidationOrderTicket);
        }
        if (message.maxLiquidationOrderDuration !== undefined) {
            duration_1.Duration.encode(message.maxLiquidationOrderDuration, writer.uint32(842).fork()).ldelim();
        }
        if (message.impactSize !== "") {
            writer.uint32(850).string(message.impactSize);
        }
        if (message.markPriceBand !== 0) {
            writer.uint32(856).uint32(message.markPriceBand);
        }
        if (message.lastPriceProtectedBand !== 0) {
            writer.uint32(864).uint32(message.lastPriceProtectedBand);
        }
        if (message.indexOracleId !== "") {
            writer.uint32(874).string(message.indexOracleId);
        }
        if (message.expiryTime !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.expiryTime), writer.uint32(882).fork()).ldelim();
        }
        if (message.isActive === true) {
            writer.uint32(888).bool(message.isActive);
        }
        if (message.isSettled === true) {
            writer.uint32(896).bool(message.isSettled);
        }
        if (!message.closedBlockHeight.isZero()) {
            writer.uint32(904).uint64(message.closedBlockHeight);
        }
        if (message.tradingBandwidth !== 0) {
            writer.uint32(912).uint32(message.tradingBandwidth);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMarket);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.displayName = reader.string();
                    break;
                case 3:
                    message.description = reader.string();
                    break;
                case 4:
                    message.marketType = reader.string();
                    break;
                case 5:
                    message.base = reader.string();
                    break;
                case 6:
                    message.quote = reader.string();
                    break;
                case 7:
                    message.basePrecision = reader.int64();
                    break;
                case 8:
                    message.quotePrecision = reader.int64();
                    break;
                case 9:
                    message.lotSize = reader.string();
                    break;
                case 10:
                    message.tickSize = reader.string();
                    break;
                case 11:
                    message.minQuantity = reader.string();
                    break;
                case 12:
                    message.makerFee = reader.string();
                    break;
                case 13:
                    message.takerFee = reader.string();
                    break;
                case 14:
                    message.createdBlockHeight = reader.uint64();
                    break;
                case 100:
                    message.riskStepSize = reader.string();
                    break;
                case 101:
                    message.initialMarginBase = reader.string();
                    break;
                case 102:
                    message.initialMarginStep = reader.string();
                    break;
                case 103:
                    message.maintenanceMarginRatio = reader.string();
                    break;
                case 104:
                    message.maxLiquidationOrderTicket = reader.string();
                    break;
                case 105:
                    message.maxLiquidationOrderDuration = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                case 106:
                    message.impactSize = reader.string();
                    break;
                case 107:
                    message.markPriceBand = reader.uint32();
                    break;
                case 108:
                    message.lastPriceProtectedBand = reader.uint32();
                    break;
                case 109:
                    message.indexOracleId = reader.string();
                    break;
                case 110:
                    message.expiryTime = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 111:
                    message.isActive = reader.bool();
                    break;
                case 112:
                    message.isSettled = reader.bool();
                    break;
                case 113:
                    message.closedBlockHeight = reader.uint64();
                    break;
                case 114:
                    message.tradingBandwidth = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMarket);
        message.name =
            object.name !== undefined && object.name !== null
                ? String(object.name)
                : "";
        message.displayName =
            object.displayName !== undefined && object.displayName !== null
                ? String(object.displayName)
                : "";
        message.description =
            object.description !== undefined && object.description !== null
                ? String(object.description)
                : "";
        message.marketType =
            object.marketType !== undefined && object.marketType !== null
                ? String(object.marketType)
                : "";
        message.base =
            object.base !== undefined && object.base !== null
                ? String(object.base)
                : "";
        message.quote =
            object.quote !== undefined && object.quote !== null
                ? String(object.quote)
                : "";
        message.basePrecision =
            object.basePrecision !== undefined && object.basePrecision !== null
                ? long_1.default.fromString(object.basePrecision)
                : long_1.default.ZERO;
        message.quotePrecision =
            object.quotePrecision !== undefined && object.quotePrecision !== null
                ? long_1.default.fromString(object.quotePrecision)
                : long_1.default.ZERO;
        message.lotSize =
            object.lotSize !== undefined && object.lotSize !== null
                ? String(object.lotSize)
                : "";
        message.tickSize =
            object.tickSize !== undefined && object.tickSize !== null
                ? String(object.tickSize)
                : "";
        message.minQuantity =
            object.minQuantity !== undefined && object.minQuantity !== null
                ? String(object.minQuantity)
                : "";
        message.makerFee =
            object.makerFee !== undefined && object.makerFee !== null
                ? String(object.makerFee)
                : "";
        message.takerFee =
            object.takerFee !== undefined && object.takerFee !== null
                ? String(object.takerFee)
                : "";
        message.createdBlockHeight =
            object.createdBlockHeight !== undefined &&
                object.createdBlockHeight !== null
                ? long_1.default.fromString(object.createdBlockHeight)
                : long_1.default.UZERO;
        message.riskStepSize =
            object.riskStepSize !== undefined && object.riskStepSize !== null
                ? String(object.riskStepSize)
                : "";
        message.initialMarginBase =
            object.initialMarginBase !== undefined &&
                object.initialMarginBase !== null
                ? String(object.initialMarginBase)
                : "";
        message.initialMarginStep =
            object.initialMarginStep !== undefined &&
                object.initialMarginStep !== null
                ? String(object.initialMarginStep)
                : "";
        message.maintenanceMarginRatio =
            object.maintenanceMarginRatio !== undefined &&
                object.maintenanceMarginRatio !== null
                ? String(object.maintenanceMarginRatio)
                : "";
        message.maxLiquidationOrderTicket =
            object.maxLiquidationOrderTicket !== undefined &&
                object.maxLiquidationOrderTicket !== null
                ? String(object.maxLiquidationOrderTicket)
                : "";
        message.maxLiquidationOrderDuration =
            object.maxLiquidationOrderDuration !== undefined &&
                object.maxLiquidationOrderDuration !== null
                ? duration_1.Duration.fromJSON(object.maxLiquidationOrderDuration)
                : undefined;
        message.impactSize =
            object.impactSize !== undefined && object.impactSize !== null
                ? String(object.impactSize)
                : "";
        message.markPriceBand =
            object.markPriceBand !== undefined && object.markPriceBand !== null
                ? Number(object.markPriceBand)
                : 0;
        message.lastPriceProtectedBand =
            object.lastPriceProtectedBand !== undefined &&
                object.lastPriceProtectedBand !== null
                ? Number(object.lastPriceProtectedBand)
                : 0;
        message.indexOracleId =
            object.indexOracleId !== undefined && object.indexOracleId !== null
                ? String(object.indexOracleId)
                : "";
        message.expiryTime =
            object.expiryTime !== undefined && object.expiryTime !== null
                ? fromJsonTimestamp(object.expiryTime)
                : undefined;
        message.isActive =
            object.isActive !== undefined && object.isActive !== null
                ? Boolean(object.isActive)
                : false;
        message.isSettled =
            object.isSettled !== undefined && object.isSettled !== null
                ? Boolean(object.isSettled)
                : false;
        message.closedBlockHeight =
            object.closedBlockHeight !== undefined &&
                object.closedBlockHeight !== null
                ? long_1.default.fromString(object.closedBlockHeight)
                : long_1.default.UZERO;
        message.tradingBandwidth =
            object.tradingBandwidth !== undefined && object.tradingBandwidth !== null
                ? Number(object.tradingBandwidth)
                : 0;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.name !== undefined && (obj.name = message.name);
        message.displayName !== undefined &&
            (obj.displayName = message.displayName);
        message.description !== undefined &&
            (obj.description = message.description);
        message.marketType !== undefined && (obj.marketType = message.marketType);
        message.base !== undefined && (obj.base = message.base);
        message.quote !== undefined && (obj.quote = message.quote);
        message.basePrecision !== undefined &&
            (obj.basePrecision = (message.basePrecision || long_1.default.ZERO).toString());
        message.quotePrecision !== undefined &&
            (obj.quotePrecision = (message.quotePrecision || long_1.default.ZERO).toString());
        message.lotSize !== undefined && (obj.lotSize = message.lotSize);
        message.tickSize !== undefined && (obj.tickSize = message.tickSize);
        message.minQuantity !== undefined &&
            (obj.minQuantity = message.minQuantity);
        message.makerFee !== undefined && (obj.makerFee = message.makerFee);
        message.takerFee !== undefined && (obj.takerFee = message.takerFee);
        message.createdBlockHeight !== undefined &&
            (obj.createdBlockHeight = (message.createdBlockHeight || long_1.default.UZERO).toString());
        message.riskStepSize !== undefined &&
            (obj.riskStepSize = message.riskStepSize);
        message.initialMarginBase !== undefined &&
            (obj.initialMarginBase = message.initialMarginBase);
        message.initialMarginStep !== undefined &&
            (obj.initialMarginStep = message.initialMarginStep);
        message.maintenanceMarginRatio !== undefined &&
            (obj.maintenanceMarginRatio = message.maintenanceMarginRatio);
        message.maxLiquidationOrderTicket !== undefined &&
            (obj.maxLiquidationOrderTicket = message.maxLiquidationOrderTicket);
        message.maxLiquidationOrderDuration !== undefined &&
            (obj.maxLiquidationOrderDuration = message.maxLiquidationOrderDuration
                ? duration_1.Duration.toJSON(message.maxLiquidationOrderDuration)
                : undefined);
        message.impactSize !== undefined && (obj.impactSize = message.impactSize);
        message.markPriceBand !== undefined &&
            (obj.markPriceBand = message.markPriceBand);
        message.lastPriceProtectedBand !== undefined &&
            (obj.lastPriceProtectedBand = message.lastPriceProtectedBand);
        message.indexOracleId !== undefined &&
            (obj.indexOracleId = message.indexOracleId);
        message.expiryTime !== undefined &&
            (obj.expiryTime = message.expiryTime.toISOString());
        message.isActive !== undefined && (obj.isActive = message.isActive);
        message.isSettled !== undefined && (obj.isSettled = message.isSettled);
        message.closedBlockHeight !== undefined &&
            (obj.closedBlockHeight = (message.closedBlockHeight || long_1.default.UZERO).toString());
        message.tradingBandwidth !== undefined &&
            (obj.tradingBandwidth = message.tradingBandwidth);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
        const message = Object.assign({}, baseMarket);
        message.name = (_a = object.name) !== null && _a !== void 0 ? _a : "";
        message.displayName = (_b = object.displayName) !== null && _b !== void 0 ? _b : "";
        message.description = (_c = object.description) !== null && _c !== void 0 ? _c : "";
        message.marketType = (_d = object.marketType) !== null && _d !== void 0 ? _d : "";
        message.base = (_e = object.base) !== null && _e !== void 0 ? _e : "";
        message.quote = (_f = object.quote) !== null && _f !== void 0 ? _f : "";
        message.basePrecision =
            object.basePrecision !== undefined && object.basePrecision !== null
                ? long_1.default.fromValue(object.basePrecision)
                : long_1.default.ZERO;
        message.quotePrecision =
            object.quotePrecision !== undefined && object.quotePrecision !== null
                ? long_1.default.fromValue(object.quotePrecision)
                : long_1.default.ZERO;
        message.lotSize = (_g = object.lotSize) !== null && _g !== void 0 ? _g : "";
        message.tickSize = (_h = object.tickSize) !== null && _h !== void 0 ? _h : "";
        message.minQuantity = (_j = object.minQuantity) !== null && _j !== void 0 ? _j : "";
        message.makerFee = (_k = object.makerFee) !== null && _k !== void 0 ? _k : "";
        message.takerFee = (_l = object.takerFee) !== null && _l !== void 0 ? _l : "";
        message.createdBlockHeight =
            object.createdBlockHeight !== undefined &&
                object.createdBlockHeight !== null
                ? long_1.default.fromValue(object.createdBlockHeight)
                : long_1.default.UZERO;
        message.riskStepSize = (_m = object.riskStepSize) !== null && _m !== void 0 ? _m : "";
        message.initialMarginBase = (_o = object.initialMarginBase) !== null && _o !== void 0 ? _o : "";
        message.initialMarginStep = (_p = object.initialMarginStep) !== null && _p !== void 0 ? _p : "";
        message.maintenanceMarginRatio = (_q = object.maintenanceMarginRatio) !== null && _q !== void 0 ? _q : "";
        message.maxLiquidationOrderTicket = (_r = object.maxLiquidationOrderTicket) !== null && _r !== void 0 ? _r : "";
        message.maxLiquidationOrderDuration =
            object.maxLiquidationOrderDuration !== undefined &&
                object.maxLiquidationOrderDuration !== null
                ? duration_1.Duration.fromPartial(object.maxLiquidationOrderDuration)
                : undefined;
        message.impactSize = (_s = object.impactSize) !== null && _s !== void 0 ? _s : "";
        message.markPriceBand = (_t = object.markPriceBand) !== null && _t !== void 0 ? _t : 0;
        message.lastPriceProtectedBand = (_u = object.lastPriceProtectedBand) !== null && _u !== void 0 ? _u : 0;
        message.indexOracleId = (_v = object.indexOracleId) !== null && _v !== void 0 ? _v : "";
        message.expiryTime = (_w = object.expiryTime) !== null && _w !== void 0 ? _w : undefined;
        message.isActive = (_x = object.isActive) !== null && _x !== void 0 ? _x : false;
        message.isSettled = (_y = object.isSettled) !== null && _y !== void 0 ? _y : false;
        message.closedBlockHeight =
            object.closedBlockHeight !== undefined &&
                object.closedBlockHeight !== null
                ? long_1.default.fromValue(object.closedBlockHeight)
                : long_1.default.UZERO;
        message.tradingBandwidth = (_z = object.tradingBandwidth) !== null && _z !== void 0 ? _z : 0;
        return message;
    },
};
const baseMarketParams = {
    name: "",
    lotSize: "",
    tickSize: "",
    minQuantity: "",
    makerFee: "",
    takerFee: "",
    riskStepSize: "",
    initialMarginBase: "",
    initialMarginStep: "",
    maintenanceMarginRatio: "",
    maxLiquidationOrderTicket: "",
    impactSize: "",
};
exports.MarketParams = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.name !== "") {
            writer.uint32(10).string(message.name);
        }
        if (message.displayName !== undefined) {
            wrappers_1.StringValue.encode({ value: message.displayName }, writer.uint32(18).fork()).ldelim();
        }
        if (message.description !== undefined) {
            wrappers_1.StringValue.encode({ value: message.description }, writer.uint32(26).fork()).ldelim();
        }
        if (message.lotSize !== "") {
            writer.uint32(82).string(message.lotSize);
        }
        if (message.tickSize !== "") {
            writer.uint32(90).string(message.tickSize);
        }
        if (message.minQuantity !== "") {
            writer.uint32(98).string(message.minQuantity);
        }
        if (message.makerFee !== "") {
            writer.uint32(106).string(message.makerFee);
        }
        if (message.takerFee !== "") {
            writer.uint32(114).string(message.takerFee);
        }
        if (message.riskStepSize !== "") {
            writer.uint32(802).string(message.riskStepSize);
        }
        if (message.initialMarginBase !== "") {
            writer.uint32(810).string(message.initialMarginBase);
        }
        if (message.initialMarginStep !== "") {
            writer.uint32(818).string(message.initialMarginStep);
        }
        if (message.maintenanceMarginRatio !== "") {
            writer.uint32(826).string(message.maintenanceMarginRatio);
        }
        if (message.maxLiquidationOrderTicket !== "") {
            writer.uint32(834).string(message.maxLiquidationOrderTicket);
        }
        if (message.maxLiquidationOrderDuration !== undefined) {
            duration_1.Duration.encode(message.maxLiquidationOrderDuration, writer.uint32(842).fork()).ldelim();
        }
        if (message.impactSize !== "") {
            writer.uint32(850).string(message.impactSize);
        }
        if (message.markPriceBand !== undefined) {
            wrappers_1.UInt32Value.encode({ value: message.markPriceBand }, writer.uint32(858).fork()).ldelim();
        }
        if (message.lastPriceProtectedBand !== undefined) {
            wrappers_1.UInt32Value.encode({ value: message.lastPriceProtectedBand }, writer.uint32(866).fork()).ldelim();
        }
        if (message.isActive !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.isActive }, writer.uint32(890).fork()).ldelim();
        }
        if (message.tradingBandwidth !== undefined) {
            wrappers_1.UInt32Value.encode({ value: message.tradingBandwidth }, writer.uint32(914).fork()).ldelim();
        }
        if (message.expiryTime !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.expiryTime), writer.uint32(922).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMarketParams);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.displayName = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 3:
                    message.description = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 10:
                    message.lotSize = reader.string();
                    break;
                case 11:
                    message.tickSize = reader.string();
                    break;
                case 12:
                    message.minQuantity = reader.string();
                    break;
                case 13:
                    message.makerFee = reader.string();
                    break;
                case 14:
                    message.takerFee = reader.string();
                    break;
                case 100:
                    message.riskStepSize = reader.string();
                    break;
                case 101:
                    message.initialMarginBase = reader.string();
                    break;
                case 102:
                    message.initialMarginStep = reader.string();
                    break;
                case 103:
                    message.maintenanceMarginRatio = reader.string();
                    break;
                case 104:
                    message.maxLiquidationOrderTicket = reader.string();
                    break;
                case 105:
                    message.maxLiquidationOrderDuration = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                case 106:
                    message.impactSize = reader.string();
                    break;
                case 107:
                    message.markPriceBand = wrappers_1.UInt32Value.decode(reader, reader.uint32()).value;
                    break;
                case 108:
                    message.lastPriceProtectedBand = wrappers_1.UInt32Value.decode(reader, reader.uint32()).value;
                    break;
                case 111:
                    message.isActive = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 114:
                    message.tradingBandwidth = wrappers_1.UInt32Value.decode(reader, reader.uint32()).value;
                    break;
                case 115:
                    message.expiryTime = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMarketParams);
        message.name =
            object.name !== undefined && object.name !== null
                ? String(object.name)
                : "";
        message.displayName =
            object.displayName !== undefined && object.displayName !== null
                ? String(object.displayName)
                : undefined;
        message.description =
            object.description !== undefined && object.description !== null
                ? String(object.description)
                : undefined;
        message.lotSize =
            object.lotSize !== undefined && object.lotSize !== null
                ? String(object.lotSize)
                : "";
        message.tickSize =
            object.tickSize !== undefined && object.tickSize !== null
                ? String(object.tickSize)
                : "";
        message.minQuantity =
            object.minQuantity !== undefined && object.minQuantity !== null
                ? String(object.minQuantity)
                : "";
        message.makerFee =
            object.makerFee !== undefined && object.makerFee !== null
                ? String(object.makerFee)
                : "";
        message.takerFee =
            object.takerFee !== undefined && object.takerFee !== null
                ? String(object.takerFee)
                : "";
        message.riskStepSize =
            object.riskStepSize !== undefined && object.riskStepSize !== null
                ? String(object.riskStepSize)
                : "";
        message.initialMarginBase =
            object.initialMarginBase !== undefined &&
                object.initialMarginBase !== null
                ? String(object.initialMarginBase)
                : "";
        message.initialMarginStep =
            object.initialMarginStep !== undefined &&
                object.initialMarginStep !== null
                ? String(object.initialMarginStep)
                : "";
        message.maintenanceMarginRatio =
            object.maintenanceMarginRatio !== undefined &&
                object.maintenanceMarginRatio !== null
                ? String(object.maintenanceMarginRatio)
                : "";
        message.maxLiquidationOrderTicket =
            object.maxLiquidationOrderTicket !== undefined &&
                object.maxLiquidationOrderTicket !== null
                ? String(object.maxLiquidationOrderTicket)
                : "";
        message.maxLiquidationOrderDuration =
            object.maxLiquidationOrderDuration !== undefined &&
                object.maxLiquidationOrderDuration !== null
                ? duration_1.Duration.fromJSON(object.maxLiquidationOrderDuration)
                : undefined;
        message.impactSize =
            object.impactSize !== undefined && object.impactSize !== null
                ? String(object.impactSize)
                : "";
        message.markPriceBand =
            object.markPriceBand !== undefined && object.markPriceBand !== null
                ? Number(object.markPriceBand)
                : undefined;
        message.lastPriceProtectedBand =
            object.lastPriceProtectedBand !== undefined &&
                object.lastPriceProtectedBand !== null
                ? Number(object.lastPriceProtectedBand)
                : undefined;
        message.isActive =
            object.isActive !== undefined && object.isActive !== null
                ? Boolean(object.isActive)
                : undefined;
        message.tradingBandwidth =
            object.tradingBandwidth !== undefined && object.tradingBandwidth !== null
                ? Number(object.tradingBandwidth)
                : undefined;
        message.expiryTime =
            object.expiryTime !== undefined && object.expiryTime !== null
                ? fromJsonTimestamp(object.expiryTime)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.name !== undefined && (obj.name = message.name);
        message.displayName !== undefined &&
            (obj.displayName = message.displayName);
        message.description !== undefined &&
            (obj.description = message.description);
        message.lotSize !== undefined && (obj.lotSize = message.lotSize);
        message.tickSize !== undefined && (obj.tickSize = message.tickSize);
        message.minQuantity !== undefined &&
            (obj.minQuantity = message.minQuantity);
        message.makerFee !== undefined && (obj.makerFee = message.makerFee);
        message.takerFee !== undefined && (obj.takerFee = message.takerFee);
        message.riskStepSize !== undefined &&
            (obj.riskStepSize = message.riskStepSize);
        message.initialMarginBase !== undefined &&
            (obj.initialMarginBase = message.initialMarginBase);
        message.initialMarginStep !== undefined &&
            (obj.initialMarginStep = message.initialMarginStep);
        message.maintenanceMarginRatio !== undefined &&
            (obj.maintenanceMarginRatio = message.maintenanceMarginRatio);
        message.maxLiquidationOrderTicket !== undefined &&
            (obj.maxLiquidationOrderTicket = message.maxLiquidationOrderTicket);
        message.maxLiquidationOrderDuration !== undefined &&
            (obj.maxLiquidationOrderDuration = message.maxLiquidationOrderDuration
                ? duration_1.Duration.toJSON(message.maxLiquidationOrderDuration)
                : undefined);
        message.impactSize !== undefined && (obj.impactSize = message.impactSize);
        message.markPriceBand !== undefined &&
            (obj.markPriceBand = message.markPriceBand);
        message.lastPriceProtectedBand !== undefined &&
            (obj.lastPriceProtectedBand = message.lastPriceProtectedBand);
        message.isActive !== undefined && (obj.isActive = message.isActive);
        message.tradingBandwidth !== undefined &&
            (obj.tradingBandwidth = message.tradingBandwidth);
        message.expiryTime !== undefined &&
            (obj.expiryTime = message.expiryTime.toISOString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
        const message = Object.assign({}, baseMarketParams);
        message.name = (_a = object.name) !== null && _a !== void 0 ? _a : "";
        message.displayName = (_b = object.displayName) !== null && _b !== void 0 ? _b : undefined;
        message.description = (_c = object.description) !== null && _c !== void 0 ? _c : undefined;
        message.lotSize = (_d = object.lotSize) !== null && _d !== void 0 ? _d : "";
        message.tickSize = (_e = object.tickSize) !== null && _e !== void 0 ? _e : "";
        message.minQuantity = (_f = object.minQuantity) !== null && _f !== void 0 ? _f : "";
        message.makerFee = (_g = object.makerFee) !== null && _g !== void 0 ? _g : "";
        message.takerFee = (_h = object.takerFee) !== null && _h !== void 0 ? _h : "";
        message.riskStepSize = (_j = object.riskStepSize) !== null && _j !== void 0 ? _j : "";
        message.initialMarginBase = (_k = object.initialMarginBase) !== null && _k !== void 0 ? _k : "";
        message.initialMarginStep = (_l = object.initialMarginStep) !== null && _l !== void 0 ? _l : "";
        message.maintenanceMarginRatio = (_m = object.maintenanceMarginRatio) !== null && _m !== void 0 ? _m : "";
        message.maxLiquidationOrderTicket = (_o = object.maxLiquidationOrderTicket) !== null && _o !== void 0 ? _o : "";
        message.maxLiquidationOrderDuration =
            object.maxLiquidationOrderDuration !== undefined &&
                object.maxLiquidationOrderDuration !== null
                ? duration_1.Duration.fromPartial(object.maxLiquidationOrderDuration)
                : undefined;
        message.impactSize = (_p = object.impactSize) !== null && _p !== void 0 ? _p : "";
        message.markPriceBand = (_q = object.markPriceBand) !== null && _q !== void 0 ? _q : undefined;
        message.lastPriceProtectedBand = (_r = object.lastPriceProtectedBand) !== null && _r !== void 0 ? _r : undefined;
        message.isActive = (_s = object.isActive) !== null && _s !== void 0 ? _s : undefined;
        message.tradingBandwidth = (_t = object.tradingBandwidth) !== null && _t !== void 0 ? _t : undefined;
        message.expiryTime = (_u = object.expiryTime) !== null && _u !== void 0 ? _u : undefined;
        return message;
    },
};
function toTimestamp(date) {
    const seconds = numberToLong(date.getTime() / 1000);
    const nanos = (date.getTime() % 1000) * 1000000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = t.seconds.toNumber() * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof Date) {
        return o;
    }
    else if (typeof o === "string") {
        return new Date(o);
    }
    else {
        return fromTimestamp(timestamp_1.Timestamp.fromJSON(o));
    }
}
function numberToLong(number) {
    return long_1.default.fromNumber(number);
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
